<template>
  <BCard class="min-w-[100px]">
    <div>
      <!-- Header Section -->
      <div class="mb-2">
        <div class="flex gap-[12px]">
          <BButton
            variant="primary"
            size="sm"
            class="rounded-[6px]"
            @click="goBack()"
          >
            <img
              class="w-[20px]"
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/arrow-left-2.svg"
              alt="arrow left"
            >
          </BButton>
          <div class="text-black font-semibold text-[24px]">
            Detail
            <span class="capitalize">{{ this.$route.query.platform }}</span> -
            Komads Whitelist
          </div>
        </div>
      </div>

      <div class="border border-solid p-[8px] rounded-lg">
        <!-- Total Spending Card -->
        <div class="bg-[#F8F8F8] p-1 rounded mb-2 border border-solid">
          <div>
            <div class="flex items-center gap-[8px]">
              <img
                alt="usd"
                src="https://storage.googleapis.com/komerce/assets/icons/usd-coin-green.svg"
                width="16"
                height="16"
              >
              <span class="font-medium">Total Spending</span>
              <img
                v-b-tooltip.hover.topright="{
                  title: 'Total spending dari semua akun whitelisted yang kamu miliki',
                  customClass: 'dark-tooltip'
                }"
                src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
                alt="info"
                width="12"
                height="12"
              >
            </div>
            <h1 class="text-black text-[24px] font-semibold mb-0">
              {{ IDR(accountData.total_spending) }}
            </h1>
          </div>
        </div>
        <!-- Action Buttons -->
        <div class="d-flex gap-8 mb-2">
          <BButton
            v-if="platform === 'meta'"
            variant="outline-primary"
            size="sm"
            @click="openSpendingFeeModal"
          >
            <div class="flex flex-row items-center gap-[4px]">
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/percentage-circle.svg"
                alt="percentage"
                width="16"
                height="16"
              >
              <span>
                Sesuaikan Fee Top Up
              </span>
            </div>
          </BButton>
          <BButton
            variant="primary"
            size="sm"
            @click="openAddAccountModal"
          >
            <div class="flex flex-row items-center gap-[4px]">
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/user-add.svg"
                alt="user-add"
                width="16"
                height="16"
              >
              <span>
                Tambah Akun Whitelisted
              </span>
            </div>
          </BButton>
          <BButton
            v-if="platform !== 'meta'"
            variant="outline-primary"
            size="sm"
            @click="openHistorySubscription"
          >
            <div class="flex flex-row items-center gap-[4px]">
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/video-time.svg"
                alt="video-time"
                width="16"
                height="16"
              >
              <span>
                Riwayat Langganan
              </span>
            </div>
          </BButton>
        </div>

        <!-- Accounts Table -->
        <div class="border rounded-[8px] overflow-hidden">
          <BTable
            :items="accountData.whitelist_account_list"
            :fields="fields"
            :busy="loading"
            striped
            hover
            show-empty
            empty-text="Tidak ada data yang tersedia"
            class="mb-0"
          >
            <!-- No Column -->
            <template #cell(no)="data">
              <span class="text-muted">{{ data.index + 1 }}</span>
            </template>

            <!-- Nama Akun Column -->
            <template #cell(nama_akun)="data">
              <div class="font-weight-medium">
                {{ data.item.name }}
              </div>
            </template>

            <!-- ID BM Column -->
            <template #cell(bm_id)="data">
              <div class="flex items-center gap-[8px]">
                <span class="text-break">{{ data.item.bm_id || '-' }}</span>
              </div>
            </template>

            <!-- Account Type Column -->
            <template #cell(ad_account_type)="data">
              <div class="flex items-center gap-[8px]">
                <span
                  v-if="data.item.platform_name === 'meta' && !!data.item.ad_account_type"
                  v-b-tooltip.hover="{
                    title: adAccountType[accountTypeProperty(data.item)].tooltipTitle,
                    customClass: 'dark-tooltip'
                  }"
                  :class="adAccountType[accountTypeProperty(data.item)].class"
                >{{ adAccountType[accountTypeProperty(data.item)].text }}</span>
              </div>
            </template>

            <!-- Gmail Column -->
            <template #cell(gmail)="data">
              <span class="text-break">{{
                data.item.gmail || '-'
              }}</span>
            </template>

            <!-- BC ID Column -->
            <template #cell(bc_id)="data">
              <span class="text-break">{{
                data.item.bc_id || '-'
              }}</span>
            </template>

            <!-- Total Spending Column -->
            <template #cell(total_spending)="data">
              <span class="font-weight-bold">
                {{ IDR(data.item.total_spending) }}
              </span>
            </template>

            <!-- Actions Column -->
            <template #cell(actions)="data">
              <div class="d-flex justify-content-center">
                <div v-if="data.item.platform_name === 'meta'">
                  <b-button
                    :id="`popover-btn-${data.item.id}`"
                    variant="link"
                    class="p-0 text-decoration-none min-w-[44px] min-h-[44px]"
                    @click="openActionPopover(data.item)"
                  >
                    <img
                      src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/more.svg"
                      alt="more-icon"
                    >
                  </b-button>
                  <b-popover
                    :id="`popover-${data.item.id}`"
                    :target="`popover-btn-${data.item.id}`"
                    placement="bottomLeft"
                    variant="white"
                    :show="data.item.id === selectedAccount.id"
                    triggers="focus"
                  >
                    <b-button
                      variant="link"
                      class="w-full text-left !text-[#333333] hover:bg-gray-100"
                      @click="openActionModal('modal-edit-account')"
                    >
                      <div class="flex items-center gap-[.5rem]">
                        <span class="text-[20px] k-edit" /><span>Edit Akun</span>
                      </div>
                    </b-button>
                    <b-button
                      variant="link"
                      class="w-full text-left !text-[#333333] hover:bg-gray-100"
                      @click="openActionModal('modal-estimate-balance')"
                    >
                      <div class="flex items-center gap-[.5rem]">
                        <span class="text-[20px] k-card" /><span>Cek Estimasi Saldo</span>
                      </div>
                    </b-button>
                    <b-button
                      variant="link"
                      class="w-full text-left !text-[#333333] hover:bg-gray-100"
                      @click="handleSynchronizeBalance(data.item)"
                    >
                      <div class="flex items-center gap-[.5rem]">
                        <span class="text-[20px] k-refresh-circle" /><span>Sinkron Saldo</span>
                      </div>
                    </b-button>
                  </b-popover>
                </div>
                <BButton
                  v-else
                  v-b-tooltip.hover.top="{ title: 'Edit akun', customClass: 'dark-tooltip' }"
                  variant="link"
                  size="sm"
                  class="p-0 text-decoration-none"
                  @click="openActionModalWithItem({ item: data.item, modalId: 'modal-edit-account' })"
                >
                  <feather-icon
                    icon="EditIcon"
                    size="16"
                    class="text-primary"
                  />
                </BButton>
              </div>
            </template>

            <!-- Loading Slot -->
            <template #table-busy>
              <div class="text-center text-primary my-4">
                <BSpinner class="align-middle" />
                <strong class="ml-2">Loading...</strong>
              </div>
            </template>
          </BTable>
        </div>
      </div>

      <!-- Modals -->
      <ModalSpendingFee
        :current-fee-percentage="currentFeePercentage"
        @update-fee="handleUpdateFee"
      />
      <ModalAddAccount
        :validation-error="submitValidationError"
        :platform="platform"
        @add-account="handleAddAccount"
        @select-ad-type="resetSubmitValidationError"
      />
      <ModalEditAccount
        :account-data="selectedAccount"
        :validation-error="submitValidationError"
        :platform="platform"
        @edit-account="handleEditAccount"
      />
      <ModalEstimateBalance
        id="modal-estimate-balance"
        :account="selectedAccount"
        @hidden="resetSelectedAccount"
      />
    </div>
  </BCard>
</template>

<script>
import {
  BCard, BTable, BButton, BSpinner,
} from 'bootstrap-vue'
import { IDR } from '@/libs/currency'
import { newAxiosIns } from '@/libs/axios'
import { MONTH_YEAR } from '@/libs/filterDate'
import { baseFields, platformFields, commonFields } from './config'
import ModalSpendingFee from './ModalSpendingFee.vue'
import ModalAddAccount from './ModalAddAccount.vue'
import ModalEditAccount from './ModalEditAccount.vue'
import ModalEstimateBalance from './ModalEstimateBalance.vue'

export default {
  name: 'Platform',
  components: {
    BCard,
    BTable,
    BButton,
    BSpinner,
    ModalSpendingFee,
    ModalAddAccount,
    ModalEditAccount,
    ModalEstimateBalance,
  },
  data() {
    return {
      IDR,
      loading: false,
      selectedAccount: {},
      submitValidationError: {
        account_name: '',
        system_bm_id: '',
        ad_account_id: '',
      },
      accountData: null,
      filterMonth: new Date(),
      currentFeePercentage: null,
      adAccountType: {
        whitelist: { class: 'ad-type-badge-blue', text: 'Whitelisted', tooltipTitle: 'Meta Whitelisted' },
        cpastokopedia: { class: 'ad-type-badge-green', text: 'CPAS', tooltipTitle: 'CPAS Tokopedia' },
        cpasshopee: { class: 'ad-type-badge-orange', text: 'CPAS', tooltipTitle: 'CPAS Shopee' },
        cpas: { class: '', text: 'CPAS', tooltipTitle: 'CPAS' },
      },
    }
  },
  computed: {
    partnerId() {
      return this.$route.params.id
    },
    platform() {
      return this.$route.query.platform || 'meta'
    },
    platformTitle() {
      const platforms = {
        meta: 'Meta',
        google: 'Google',
        tiktok: 'TikTok',
      }
      return platforms[this.platform] || 'Meta'
    },
    /**
     * Dynamic responsive fields based on platform type and screen size
     * @returns {Array} Responsive column configuration
     */
    fields() {
      return [
        ...baseFields,
        ...(platformFields[this.platform] || platformFields.meta),
        ...commonFields,
      ]
    },
  },
  mounted() {
    this.getWhitelistInfo()
  },
  methods: {
    /**
     * Generate a unique property key for account type based on account data
     * @param {Object} account - Account data containing ad_account_type and marketplace
     * @returns {string} Unique property key for account type
     */
    accountTypeProperty(account) {
      return `${account.ad_account_type}${account.marketplace || ''}`
    },

    goBack() {
      this.$router.push(`/komads/data-partner/${this.partnerId}`)
    },

    /**
     * Format percentage with 2 decimal places
     * @param {number} value - Value to format
     * @returns {string} Formatted percentage string
     */
    formatPercentage(value) {
      return parseFloat(value).toFixed(2)
    },

    /**
     * Get whitelist information from API
     * @returns {Promise<void>}
     */
    async getWhitelistInfo() {
      const { id } = this.$route.params
      this.loading = true

      try {
        const { data } = await newAxiosIns.get(
          `komads/api/v1/admin/partners/${id}/whitelist_info`,
          {
            params: {
              month: MONTH_YEAR(this.filterMonth),
              platform_name: this.platform,
            },
          },
        )
        this.accountData = data.data
        this.accountData.whitelist_account_list = this.accountData.whitelist_account_list.map(acc => ({ ...acc, showPopover: false }))
        this.currentFeePercentage = this.accountData.fee_topups?.find(
          item => item.platform_name === this.platform,
        ).fee_topup || 5
      } catch (error) {
        this.$toast_error({
          message: 'Gagal mengambil data',
        })
      } finally {
        this.loading = false
      }
    },

    /**
     * Open spending fee modal
     */
    openSpendingFeeModal() {
      this.$bvModal.show('modal-spending-fee')
    },

    /**
     * Open add account modal
     */
    openAddAccountModal() {
      this.resetSubmitValidationError()
      this.$bvModal.show('modal-add-account')
    },
    /**
     * Open history section
     */
    openHistorySubscription() {
      this.$router.push({
        path: `/komads/data-partner/${this.partnerId}/detail/history-subscription`,
        query: {
          platform: this.platform,
        },
      })
    },

    /**
     * Open action modal
     * @param {String} modalId - Account data to edit
     */
    openActionModal(modalId) {
      this.resetSubmitValidationError()
      this.$bvModal.show(modalId)
    },

    /**
     * Open action modal with selected account data
     * @param {Object} item - Account data to edit
     */
    openActionModalWithItem({ item, modalId }) {
      this.selectedAccount = item
      this.openActionModal(modalId)
    },

    /**
     * Handle update fee percentage action
     * @param {number} feePercentage - New fee percentage
     * @returns {Promise<void>}
     */
    async handleUpdateFee(feePercentage) {
      const { id } = this.$route.params

      try {
        await newAxiosIns.put(
          `komads/api/v1/admin/partners/${id}/whitelist_update`,
          {
            account_id: this.accountData.account_id,
            fee_topup: feePercentage,
            platform_name: this.platform,
          },
        )

        this.currentFeePercentage = feePercentage
        this.$toast_success({
          message: 'Fee top up berhasil diubah',
        })
      } catch (error) {
        this.$toast_error({
          message: 'Gagal mengubah fee top up',
        })
      } finally {
        this.getWhitelistInfo()
      }
    },

    /**
     * Handle add account from modal
     * @param {Object} form - Form data with account_name and bm_id
     * @returns {Promise<void>}
     */
    async handleAddAccount(form) {
      this.resetSubmitValidationError()
      const { id } = this.$route.params

      try {
        await newAxiosIns.post('komads/api/v1/admin/whitelist_accounts/store', {
          user_id: Number(id),
          account_id: this.accountData.account_id,
          whitelist_name: form.account_name,
          bm_id: form.bm_id,
          platform_name: this.platform,
          gmail: form.gmail,
          bc_id: form.bc_id,
          ad_account_type: form.ad_account_type,
          system_bm_id: Number(form.system_bm_id),
          marketplace: form.marketplace,
          marketplace_email: form.marketplace_sync_email,
          ad_account_id: form.ad_account_id,
        })

        this.$toast_success({
          message: 'Akun whitelisted berhasil ditambahkan',
        })
        this.$bvModal.hide('modal-add-account')
      } catch (error) {
        if (error.response && error.response.status === 400) {
          const errorMessage = error.response.data?.meta.message || ''

          // account_name error input
          if (errorMessage.includes('account already exist')) {
            this.submitValidationError.account_name = 'Nama sudah digunakan, silahkan gunakan nama lain.'
          } else if (errorMessage.includes('ad account id not valid')) { // ad_account_id error input
            this.submitValidationError.ad_account_id = 'ID Ad Account Tidak Valid.'
          } else if (errorMessage.includes('bm limit exceeded')) { // system_bm_id error input
            this.submitValidationError.system_bm_id = 'Kuota Business Manager Sudah Penuh.'
          } else {
            this.$toast_error({
              message: errorMessage || 'Gagal menambahkan akun whitelisted',
            })
          }

          this.$bvModal.show('modal-add-account')
        } else {
          this.$toast_error({
            message: 'Gagal menambahkan akun whitelisted',
          })
        }
      } finally {
        this.getWhitelistInfo()
      }
    },

    /**
     * Handle edit account from modal
     * @param {Object} form - Form data with account_name and bm_id
     * @returns {Promise<void>}
     */
    async handleEditAccount(form) {
      this.resetSubmitValidationError()
      const accountId = this.selectedAccount?.id

      if (!accountId) {
        this.$toast_error({
          message: 'ID akun tidak ditemukan',
        })
        return
      }

      try {
        await newAxiosIns.put(
          `komads/api/v1/admin/whitelist_accounts/${accountId}/update`,
          {
            partner_id: this.accountData.partner_id,
            whitelist_name: form.account_name,
            bm_id: form.bm_id,
            system_bm_id: Number(form.system_bm_id),
            platform_name: this.platform,
            gmail: form.gmail,
            bc_id: form.bc_id,
            ad_account_id: form.ad_account_id,
          },
        )

        this.$toast_success({
          message: 'Akun whitelisted berhasil diubah',
        })
        this.$bvModal.hide('modal-edit-account')
        this.resetSelectedAccount()
      } catch (error) {
        if (error.response && error.response.status === 400) {
          const errorMessage = error.response.data?.meta.message || ''
          // account_name error input
          if (errorMessage.includes('account already exist')) {
            this.submitValidationError.account_name = 'Nama sudah digunakan, silahkan gunakan nama lain.'
          } else if (errorMessage.includes('ad account id not valid')) { // ad_account_id error input
            this.submitValidationError.ad_account_id = 'ID Ad Account Tidak Valid.'
          } else if (errorMessage.includes('bm limit exceeded')) { // system_bm_id error input
            this.submitValidationError.system_bm_id = 'Kuota Business Manager Sudah Penuh.'
          } else {
            this.$toast_error({
              message: errorMessage || 'Gagal mengubah akun whitelisted',
            })
          }

          this.$bvModal.show('modal-edit-account')
        } else {
          this.$toast_error({
            message: 'Gagal mengubah akun whitelisted',
          })
        }
      } finally {
        this.getWhitelistInfo()
      }
    },

    /**
     * Handle synchronize balance action
     * @param {Object} account - Account data to synchronize
     */
    async handleSynchronizeBalance(item) {
      this.resetSelectedAccount()
      const account = item
      if (account.isLoading) {
        this.$toast.clear()
        this.$toast_error({
          title: 'Terjadi Kesalahan',
          message: 'Tidak dapat sinkron saldo, proses masih berjalan',
        })
        return
      }
      const toastError = { title: '', message: '' }
      const toastSuccess = { title: '', message: '' }
      try {
        account.isLoading = true
        this.$toast.clear()
        this.$toast_success({
          title: 'Proses Sinkron Saldo',
          message: 'Sinkron saldo sedang berlangsung!',
        })
        await newAxiosIns.post('komads/api/v1/admin/whitelist_accounts/sync-estimated-balance', {
          whitelist_account_id: account.id,
        })
        toastSuccess.title = 'Berhasil'
        toastSuccess.message = 'Sinkron saldo berhasil!'
      } catch (error) {
        toastError.title = 'Gagal'
        toastError.message = 'Gagal melakukan proses sinkron saldo!'
        if (error.response.status === 429) {
          toastError.title = 'Terjadi Kesalahan'
          toastError.message = 'Tidak dapat sinkron saldo, silakan coba kembali beberapa saat lagi!'
        }
      } finally {
        setTimeout(() => {
          account.isLoading = false
          this.$toast.clear()
          if (toastError.title) this.$toast_error(toastError)
          else if (toastSuccess.title) {
            this.getWhitelistInfo()
            this.$toast_success(toastSuccess)
          }
        }, 5000)
      }
    },
    /**
     * Handle reset submit validation error
     * @returns {void}
     */
    resetSubmitValidationError() {
      this.submitValidationError = {
        account_name: '',
        system_bm_id: '',
        ad_account_id: '',
      }
    },

    /**
     * Handle action popover
     * @param {Object} item - Item data containing account object
     */
    openActionPopover(item) {
      this.selectedAccount = item
    },
    /**
     * Handle reset selectedAccount
     */
    resetSelectedAccount() {
      this.selectedAccount = {}
    },
  },
}
</script>
